// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const NotificationsOff = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M20,36a5.16,5.16,0,0,1-5.15-5.15.5.5,0,1,1,1,0,4.15,4.15,0,0,0,8.3,0,.5.5,0,0,1,1,0A5.16,5.16,0,0,1,20,36Z" />
            <Path d="M31.6,29.8H14.67a.5.5,0,1,1,0-1H31.6a1.82,1.82,0,0,0,0-3.65,2.75,2.75,0,0,1-2.73-2.82V16.9A8.55,8.55,0,0,0,28.65,15a.5.5,0,0,1,1-.23,9.55,9.55,0,0,1,.25,2.17v5.43a1.74,1.74,0,0,0,1.73,1.82,2.82,2.82,0,0,1,0,5.65Z" />
            <Path d="M9.67,29.8H8.35a2.82,2.82,0,1,1,0-5.65,1.74,1.74,0,0,0,1.73-1.82V16.9a9.81,9.81,0,0,1,6.3-9.11V7.6a3.6,3.6,0,1,1,7.2,0v.19a10.06,10.06,0,0,1,4.37,3.34.5.5,0,1,1-.8.6,9,9,0,0,0-4.23-3.11l-.34-.12V7.6a2.6,2.6,0,1,0-5.2,0v.9L17,8.61a8.81,8.81,0,0,0-6,8.29v5.43a2.75,2.75,0,0,1-2.73,2.82,1.82,1.82,0,1,0,0,3.65H9.67a.5.5,0,1,1,0,1Z" />
            <Path d="M14.27,17.67a.5.5,0,0,1-.5-.5,6.48,6.48,0,0,1,6.48-6.47.5.5,0,0,1,0,1,5.48,5.48,0,0,0-5.48,5.47A.5.5,0,0,1,14.27,17.67Z" />
            <Path d="M6,36a.5.5,0,0,1-.35-.85l27.5-27.5a.5.5,0,0,1,.71.71L6.33,35.85A.5.5,0,0,1,6,36Z" />
        </G>
    );
};

export default NotificationsOff;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/notifications-off/index.js